'use client'
import React from 'react'
import sanitizeHtml from 'sanitize-html'

export default function StaticContent({title, content}) {

  return (
    <article className="prose max-w-screen-md mx-auto">
      <h1 dangerouslySetInnerHTML={{ __html: sanitizeHtml(title?.rendered) }} className="text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl mb-16" />
      <div className="text-xl max-w-[38rem] leading-normal" dangerouslySetInnerHTML={{ __html: sanitizeHtml(content?.rendered) }} />
    </article>
  )
}
